const state={
  user:{
    hasLogin:false,//是否登录
    roles:[],//用户角色
    routes:[],//用户路由
    userInfo:{},//用户信息
    permissions:[],//用户权限
  },
  config:{},
  dictList:[],
}
export default state



// WEBPACK FOOTER //
// ./src/js/vuex/store/state.js